import { Spinner } from '@/components/Spinner';
import { useGetStoreDetails } from '@/features/store-management/basic-stores/hooks/useGetStoreDetails';
import ConvertBasicToPremium from '@/features/store-management/switch-store';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/(app)/store-information/basic-stores/switch-store/$id/')({
  component: RouteComponent,
});

function RouteComponent() {
  const { id } = Route.useParams();

  const { getBasicStoreDetails, isLoading } = useGetStoreDetails(id);

  if (isLoading) return <Spinner />;
  return <ConvertBasicToPremium getBasicStoreDetails={getBasicStoreDetails} id={id} />;
}
